import IconEyeSlashSolid from '@/assets/icons/font_awesome/eye-slash-solid.svg?react';
import IconEyeSolid from '@/assets/icons/font_awesome/eye-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_collections from '@/locales/keys/i18n_page_collections.json';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';

export function C_BUTTON__collection_hide_unused() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_COLLECTIONS);

  const dispatch = use_dispatch();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { page_collections_hide_unused } = use_slice_ui(['page_collections_hide_unused']);

  const i18n_key_tooltip = t(
    page_collections_hide_unused ? i18n_page_collections.button.hide_unused.tooltip.show : i18n_page_collections.button.hide_unused.tooltip.show,
  );

  function onClick() {
    dispatch(LOCAL__ui_set_boolean({ value: !page_collections_hide_unused, key: 'page_collections_hide_unused' }));
  }

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_UPDATE)) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={i18n_key_tooltip} side="right">
      <UI_PRIMITIVE__button_with_icon_animated
        className="w-10"
        size="square-10"
        iconClassNameBase="!text-component-item-foreground !size-4"
        iconClassNameHovered="!text-bar-foreground"
        variant="no-border-on-bar"
        onClick={onClick}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        Icon={page_collections_hide_unused ? IconEyeSolid : IconEyeSlashSolid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
